import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setTerm } from "../../reducers/userSlice";
import { Button, Col, Row } from "reactstrap";
import InvitationPopup from "./InvitationPopup";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useNavigate } from "react-router-dom";

const UsersSearch = () => {
    const [showInvitationPopup, setShowInvitationPopup] = useState(false);
    const [filter, setFilter] = useState('');
    const dispatch = useDispatch();

    const navigate = useNavigate()

    const onFilterChanged = (e) => {
      setFilter(e.target.value);

      if(e.target.value.length > 2) {
        dispatch(setTerm(e.target.value))
      } else {
        if(e.target.value.length < filter.length) {
          dispatch(setTerm(null))
        }
      }
    }

    return (
      <div className="bg-white p-4">
        <Row>
          <Col md="11">
            <input
                type="text"
                className="form-control"
                placeholder="Search users"
                onChange={onFilterChanged}
                defaultValue={filter}
            />
          </Col>
          <Col md="1" className="text-right">
            <Button id="new_pos_btn" color="primary" style={{whiteSpace: "nowrap"}} onClick={() => { setShowInvitationPopup(true) }} >
              <span className="fas fa-plus"></span>
            </Button>
            &nbsp;
            <Button id="new_pos_btn" color="secondary" style={{whiteSpace: "nowrap"}} onClick={() => { navigate('/users/data') }} >
              <span className="fas fa-calendar-alt"></span>
            </Button>
          </Col>
        </Row>
        {
          showInvitationPopup
            ? <InvitationPopup onToggle={() => { setShowInvitationPopup(false) }} />
            : null
        }
      </div>
    );
};

export default UsersSearch;